// handlers.js
// Trigger global event handlers.
import $ from 'jquery';
import _ from 'lodash';
import radio from 'radio';
import {
KEYUP,
RESIZE,
SCROLL,
CLICK,
TOUCHMOVE,
TOUCHSTART,
MOUSEOVER,
MOUSEUP,
MOUSEDOWN,
TRANSITIONEND,
ANIMATIONEND,
OWLTRANSLATED,
OWLCHANGE,
OWLCHANGED,
OWLINITIALIZED,
INPUTBLUR,
INPUTFOCUS,
SUBMIT,
FORMCHANGE,
} from 'shared/enums/events';

export default function () {
  const $document = $(document);
  const $window = $(window);

  // Global Events
  // Add global event handlers to the document that can be used
  // by components. Use `radio` and the $target param to target
  // elements.
  $document.on('click', (event, options) => radio(CLICK).broadcast(event, $(event.target), options));
  $document.on('keyup', (event, options) => radio(KEYUP).broadcast(event, $(event.target), options));
  $document.on('touchmove', (event, options) => radio(TOUCHMOVE).broadcast(event, $(event.target), options));
  $document.on('touchstart', (event, options) => radio(TOUCHSTART).broadcast(event, $(event.target), options));
  $document.on('mouseover', (event, options) => radio(MOUSEOVER).broadcast(event, $(event.target), options));
  $document.on('mousedown', (event, options) => radio(MOUSEDOWN).broadcast(event, $(event.target), options));
  $document.on('mouseup', (event, options) => radio(MOUSEUP).broadcast(event, $(event.target), options));
  $document.on('transitionend webkitTransitionEnd oTransitionEnd', (event, options) => radio(TRANSITIONEND).broadcast(event, $(event.target), options));
  $document.on('animationend webkitAnimationEnd oAnimationEnd msAnimationEnd', (event, options) => radio(ANIMATIONEND).broadcast(event, $(event.target), options));
  $document.on('translated.owl.carousel', (event, options) => radio(OWLTRANSLATED).broadcast(event, $(event.target), options));
  $document.on('initialized.owl.carousel', (event, options) => radio(OWLINITIALIZED).broadcast(event, $(event.target), options));
  $document.on('change.owl.carousel', (event, options) => radio(OWLCHANGE).broadcast(event, $(event.target), options));
  $document.on('changed.owl.carousel', (event, options) => radio(OWLCHANGED).broadcast(event, $(event.target), options));

  $window.on('resize', _.throttle(() => radio(RESIZE).broadcast()
  , 100));

  $document.on('scroll', _.throttle(() => radio(SCROLL).broadcast()
  , 5));

  $document.on('focus', 'input', (event, options) => radio(INPUTFOCUS).broadcast(event, $(event.target), options));
  $document.on('blur', 'input', (event, options) => radio(INPUTBLUR).broadcast(event, $(event.target), options));
  $document.on('submit', 'form', (event, options) => radio(SUBMIT).broadcast(event, $(event.target), options));
  $document.on('change', 'form', (event, options) => radio(FORMCHANGE).broadcast(event, $(event.target), options));
}



// WEBPACK FOOTER //
// ./~/unicorn/public/src/event-handlers.js
